<template>
    <div class="page-home">
        <HomeBanner></HomeBanner>
        <TreineBanners area="acima-do-destaque-na-home" class="banner-container"></TreineBanners>
        <div class="home-workouts-title">
            <div class="container">
                <div class="section-title">
                    <h2>{{ $root.t('Qual é o objetivo do seu treino hoje?') }}</h2>
                    <p>{{ $root.t('A Smart Fit sempre tem um treino gratuito que é a sua cara. Escolha o que mais combina com você e vem com a gente!') }}</p>
                </div>
            </div>
        </div>
        <RecentVideos v-if="canRenderRecentVideos()" ></RecentVideos>
        <WorkoutsList :workouts="workouts"></WorkoutsList>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WorkoutsList from '@/components/WorkoutsList'
import HomeBanner from '@/components/HomeBanner'
import RecentVideos from '@/components/RecentVideos'
import TreineBanners from '@/components/TreineBanners'


export default {
    components : {
        WorkoutsList,
        HomeBanner,
        RecentVideos,
        TreineBanners
    },
    data () {
        return {
            live : true
        }
    },
    computed : {
        ...mapGetters([
            'workouts',
            'theme'
        ]),
    },
    methods : {
        ...mapActions({
            getLives : 'getLives',
            getWorkouts : 'getWorkouts',
            getLayoutParts : 'getLayoutParts',
        }),
        canRenderRecentVideos() {
            return this.theme !== 'bioritmo'
        }
    },
    created () {
        this.getLives()
        this.getWorkouts()
        this.getLayoutParts()
    }
}
</script>

<style lang="scss" scoped>
    .page-home {
        margin-bottom: 40px;
    }
    .banner-container {
        margin-top: 40px;
    }
</style>
